<template>
  <base-section
    id="features"
    class="secondary"
  >
    <v-responsive
      class="mx-auto"
      max-width="1350"
    >
      <v-container fluid>
        <v-row class="row" >
          <v-col
            v-for="card in cards"
            :key="card.title"
            cols="12"
            sm="4"
            md="3"
          >
            <base-info-card
              align="center"
              dark
              v-bind="card"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-responsive>
  </base-section>
</template>

<script>
import Translations from '@/services/Translations'
  export default {
    name: 'SectionFeatures',
    mounted(){
      Translations.selsectedLanguage$.subscribe(() => this.cards = Translations.getMessages().sections.feauters.cards);
    },
    data: () => ({
      cards: []
    }),
  }
</script>
<style scoped lang="scss">
.row{
  justify-content: space-around;
}
</style>
